import { mdiCheckboxBlankCircleOutline } from '@mdi/js'

const themeConfig = {
  app: {
    name: 'AIC',
    logo: require('@/assets/images/svg/aic-temp2.png'),
    isDark: false,
    isRtl: false,
    contentLayoutNav: 'vertical', // vertical, horizontal
    routeTransition: 'scroll-x-transition', // https://vuetifyjs.com/en/styles/transitions/#api
    // ! `semi-dark` isn't available for horizontal nav menu
    skinVariant: 'semi-dark', // default, bordered, semi-dark
    contentWidth: 'full', // boxed, 'full'
  },
  menu: {
    isMenuHidden: false,
    isVerticalNavMini: false,
    verticalMenuAccordion: true,
    groupChildIcon: mdiCheckboxBlankCircleOutline,
    horizontalNavMenuGroupOpenOnHover: true,
  },
  appBar: {
    /*
    ! In Content Layout Horizontal Nav type `hidden` value won't work
    ! In Content Layout Horizontal Nav type value of `type` will affect both Appbar and Horizontal Navigation Menu
    */
    type: 'fixed', // fixed, static, hidden
    isBlurred: true,
  },
  footer: {
    type: 'static', // fixed, static, hidden
  },
  themes: {
    light: {
      primary: '#c3962d',
      accent: '#002395',
      secondary: '#8A8D93',
      success: '#56ca00',
      info: '#007BFF',
      warning: '#FFB400',
      error: '#FF4C51',
    },
    dark: {
      primary: '#c3962d',
      accent: '#002395',
      secondary: '#8A8D93',
      success: '#56ca00',
      info: '#007BFF',
      warning: '#FFB400',
      error: '#FF4C51',
    },
  },
}

export default themeConfig
